
import { defineComponent } from 'vue';
import { AppFormRow, AppCard, AppInput, AppButton, AppSelect } from '@/components';
import { usePicwordSetting } from '@/modules/picword/setting/model/edit';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.SETTING,
    components: { AppFormRow, AppCard, AppInput, AppButton, AppSelect },
    setup() {
        const { model, v$, picwordPetOptions, actions } = usePicwordSetting();

        return { model, v$, picwordPetOptions, actions };
    }
});
